import { format, isToday, isTomorrow } from "date-fns";

import type { ICartLayout } from "@/api/interfaces/cartLayouts";
import { IDiningOptionEnum } from "@/api/interfaces/configurationLayouts";
import {
  getUnixCurrentDate,
  getUnixDateFromUTC,
} from "@/base/utils/dateHelpers";
import {
  getSessionStorage,
  getStorage,
  SessionStorageKey,
  StorageKey,
} from "@/constants/storage";
import type { TheatreResourceState } from "@/store/theatreResource";
import { isStatus } from "@/store/utils";

export const shouldPromptTableInfo = (
  shoppingCart: ICartLayout | null | undefined,
  tableInfo: TheatreResourceState["theatreResource"],
) => {
  const barcode = getSessionStorage(SessionStorageKey.THEATER_RESOURCE);
  const cart = getStorage(StorageKey.CART);

  const isCartForTakeOut =
    shoppingCart?.Defaults?.DiningOptionID === IDiningOptionEnum.TAKE_OUT;

  const isPreorder = !!shoppingCart?.Defaults?.dttmRequestedDelivery;

  return !(
    (cart && barcode) ||
    isCartForTakeOut ||
    isStatus(tableInfo, ["succeeded", "stale"]) ||
    isPreorder
  );
};

export const formatDeliveryDateAndTime = (
  date: Date,
  todayTranslation: string,
  tomorrowTranslation: string,
) =>
  format(
    date,
    `HH:mm ${
      isToday(date)
        ? `'${todayTranslation},'`
        : isTomorrow(date)
          ? `'${tomorrowTranslation},'`
          : ""
    } dd.MM.yyyy`,
  );

export const isShoppingCartExpired = (
  shoppingCart: ICartLayout,
): boolean | undefined => {
  if (shoppingCart?.dttmExpiresUTC) {
    const expiryDate = getUnixDateFromUTC(shoppingCart.dttmExpiresUTC);
    const nowDate = getUnixCurrentDate();

    return nowDate - expiryDate > 0;
  }

  return;
};
